/* The quiet line under the chart. It normally carries the chart's standing note — what the
   equities are measured against, whether the total is inferred — and for a few seconds at a
   time whatever a save or a stroke has to say. */

import { dom } from "./layout";

let flashTimer: number | null = null;
let lastNote = "";

/** The chart's standing note. */
export function setNote(text: string): void {
  lastNote = text;
  // A flash owns the line until it expires; overwriting it would swallow the warning a save
  // just put there.
  if (flashTimer === null) dom.approx.textContent = text;
}

export function flash(text: string, kind: "info" | "err"): void {
  dom.approx.textContent = text;
  dom.approx.className = `approx ${kind}`;
  if (flashTimer !== null) clearTimeout(flashTimer);
  // Restoring the note in place, not through render(): a full render would rebuild the
  // editor and take half-typed notation with it.
  flashTimer = window.setTimeout(() => {
    flashTimer = null;
    dom.approx.className = "approx";
    dom.approx.textContent = lastNote;
  }, 6000);
}
